import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
export default [new Extend.Model(Discussion).attribute('isTicket').attribute('ticketStatus').attribute('ticketPriority').attribute('canManageTicket').hasMany('ticketAssignees')
// Staff only, on tickets opened without an account.
.attribute('ticketGuest'), new Extend.Model(Post) //
.attribute('supportByGuest')];